import React from "react";

import styled from "@mui/material/styles/styled";

import SharedReportIcon from "@app/analytics/components/SharedReportIcon";
import { pluralizePhrase } from "@app/common/utils";

import { Link } from "@rui/Link";
import { Row } from "@rui/Stack";
import { Bold, Span } from "@rui/styles";

const Banner = styled(Row)(({ theme }) => ({
  ...theme.typography.bodySecondaryReg,
  minHeight: "48px",
  fontFamily: theme.typography.fontFamilySecondary,
  color: theme.palette.shades.neutral[700],
  backgroundColor: theme.palette.shades.secondary[100],
  padding: theme.spacing(1, 2),
}));

export const ActivelySharingBanner = ({
  numPeopleWithAccess,
  onClickShare,
}: {
  numPeopleWithAccess: number;
  onClickShare: () => void;
}) => (
  <Banner variant="left" spacing={1.5}>
    <SharedReportIcon />
    <Span>
      <Bold>Actively Sharing:</Bold> The notes section of this Readout and{" "}
      <Bold>all future updates</Bold> are being shared with{" "}
      {pluralizePhrase(numPeopleWithAccess, "person", { plural: "people" })}.
      Open <Link onClick={onClickShare}>Share</Link> to manage visibility.
    </Span>
  </Banner>
);

export const SharedReportBanner = ({ owner }: { owner?: string }) => (
  <Banner variant="left" spacing={1.5}>
    <SharedReportIcon />
    <Span>
      <Bold>Shared Report:</Bold> This Readout was shared with you
      {owner ? ` by ${owner}.` : "."} Certain actions are not available in a
      shared Readout.
    </Span>
  </Banner>
);
